import React from 'react';
import { SectionLayout } from '../../components/Layouts';
import { Row, Col } from '../../components/Grid';
import Button from '../../components/Button';
import * as S from './style';
import * as T from '../../components/Typography';
import composeStyle from '../../utils/composeStyle';

const Title = composeStyle(T.H3, 'H3', 'H4Bold');

const MoreAboutTempoAndBenefits = ({ title, description, to, bgcolor }) => {
  return (
    <S.Wrapper id="tc-benefits">
      <S.Circle />
      <SectionLayout bgcolor={bgcolor}>
        <Row mtT="10rem" mtM={0}>
          <Col w={[0, 0, 4]} />
          <Col w={[4, 6, 8]}>
            <Title color="midnight" d="block">
              {title}
            </Title>
            <T.P16 color="gray1" mt={3} mtM={1} as="pre">
              {description}
            </T.P16>
          </Col>
          {to && (
            <>
              <Col w={[0, 0, 4]} />
              <Col w={[4, 3, 4]} mt={2} mtT={4}>
                <Button color="blue" small to={to}>
                  Read more
                </Button>
              </Col>
            </>
          )}
        </Row>
      </SectionLayout>
    </S.Wrapper>
  );
};

export default MoreAboutTempoAndBenefits;
